import MainLayout from '@ui/components/templates/main-layout/main-layout.template';
import { Outlet } from 'react-router';
import useMainViewModel from './main.view-model';

export default function MainView() {
  // #region View Model
  const { errorDialog, loading } = useMainViewModel();
  // #endregion

  return (
    <MainLayout errorDialog={errorDialog} hasSuspense isLoading={loading}>
      <Outlet />
    </MainLayout>
  );
}
